import { app } from '../../../app';

class CorporateSettingsService{

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    save(companyId,settings) {
        return this.$http
            .post(`app/rest/company/${companyId}/corporateSettings/`,settings)
            .then(response => response.data);
    }

    get(companyId) {
        return this.$http
            .get(`app/rest/company/${companyId}/corporateSettings/`)
            .then(response => response.data);
    }

    setIpFilter(companyId,ipFilter) {
        return this.$http
            .post(`app/rest/company/${companyId}/setIpFilter`,ipFilter)
            .then((response) => response.data);
    }

}

app.service('CorporateSettingsService', CorporateSettingsService);


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/corporate-settings.service.js